import domready from "domready";
domready(function () {
  var alerts = document.querySelectorAll(".typo3-messages .alert");
  if (!alerts) {
    return;
  }
  Array.prototype.forEach.call(alerts, function (alert) {
    alert.classList.add("is-visible");
    alert.addEventListener("click", function (e) {
      alert.classList.remove("is-visible");
      setTimeout(function () {
        alert.remove();
      }, 250);
    });
  });
});
